import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getModel } from './selectors';
import * as actions from './actions';
import * as internalTabsActions from '../InternalTabs/actions';
import EnergyRelatedSignalsListComponent from './EnergyRelatedSignalsListComponent';

const EnergyRelatedSignalsListContainer = (props) => {
    return <EnergyRelatedSignalsListComponent {...props} />;
};

const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators({ ...actions, ...internalTabsActions }, dispatch)
    };
};

const EnergyRelatedSignalsListContainerConn = connect(
    mapStateToProps,
    mapDispatchToProps
)(EnergyRelatedSignalsListContainer);

export default EnergyRelatedSignalsListContainerConn;
